import { z } from 'zod';
import type { ClientPostConfigTask } from '../client/list';

/**
 * A checklist task on a Template. Extends the client-checklist task shape with
 * a due-date offset relative to the post's `date` (the post being created from
 * the template), so `postChecklistGenerator` can compute an absolute `dueDate`
 * for each generated task.
 */
export type TemplateChecklistTask = ClientPostConfigTask & {
  /** Days added to (or, if negative, subtracted from) the post's date. Defaults to 0. */
  dueDateOffsetDays?: number;
  /** 'HH:mm' time of day for the due date. Defaults to the post's own time of day. */
  dueDateOffsetTime?: string | null;
};

export const templateSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string().nullable().optional(),
  documentation: z.string().nullable().optional(),
  checklist: z.custom<TemplateChecklistTask[]>().optional(),
  /** True for the (single) template the auto-create-posts cron applies to generated posts/articles. */
  isDefaultForAutoCreate: z.boolean().optional(),
  order: z.number(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type TemplateSchema = z.infer<typeof templateSchema>;
